function ParentDateAddedTemplate(parent) {
    return new Date(parent.dateAdded).toLocaleDateString();
}

export default ParentDateAddedTemplate;
